import React, { useState } from 'react';
import { Tabs } from '@ampol/design-system';
import PageHeader from 'components/layout/page-header/page-header';

import CardMaintenance from 'features/maintenance/pages/card-maintenance/card-maintenance';
import ScheduledMaintenance from 'features/maintenance/pages/scheduled-maintenance/scheduled-maintenance';
import { AccessVerifier } from 'utilities/access-verifier';
import { userActionTypes } from 'utilities/user-utilities';

/**
 * Maintenance page
 * @returns JSX Element
 */
const Maintenance = () => {
  const access = AccessVerifier(['card', 'cash', 'admin'], [userActionTypes.MaintenanceRead]);
  const MaintenanceTabs = [
    {
      id: 'cardMaintenance',
      label: 'Card maintenance',
      hasAccess: access,
      children: <CardMaintenance />
    },
    {
      id: 'scheduledMaintenance',
      label: 'Scheduled maintenance',
      hasAccess: access,
      children: <ScheduledMaintenance />
    },
  ];
  const [defaultTab, setDefaultTab] = useState(MaintenanceTabs[0]);

  return <div className={'maintenance-list-page'}>
    <PageHeader title='Maintenance' />
    <Tabs items={MaintenanceTabs} currentTab={defaultTab} onTabSelected={setDefaultTab} />
  </div>;
};

export default Maintenance;
